var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeOff = function SvgLikeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#888D96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m15.537 10.596-5.186 5.186a.5.5 0 0 1-.707 0L4.46 10.596a3.667 3.667 0 1 1 5.185-5.185.5.5 0 0 0 .707 0 3.667 3.667 0 1 1 5.186 5.185Z"
  })));
};
export default SvgLikeOff;